




































import { Component, Mixins, Prop } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IContractProduct } from "@/models/contracts";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "product-image": () =>
      import("@/components/app/global/products/productImage.vue")
  }
})
export default class CProdImage extends Mixins(Context) {
  // Props

  @Prop({ default: undefined })
  public readonly contractProduct?: IContractProduct;

  @Prop({ default: undefined })
  public readonly client?: IClient;

  @Prop({ default: false })
  public readonly isLoading?: boolean;

  @Prop({ default: 64 })
  public readonly size!: number;

  @Prop({ default: 100 })
  public readonly quality!: 50 | 100 | 200 | 300 | 400;

  @Prop({ default: "2rem" })
  public readonly bottomRightSize!: number;

  @Prop({ default: "is-right" })
  public readonly tooltipPosition!: string;

  @Prop({ default: true })
  public showDelegator!: boolean;

  // Computed

  public get avatarBindings() {
    return {
      size: Math.max(this.size / 2, 32), // 32px minimum
      name: this.clientName,
      email: this.client?.email || "",
      src: this.client?.image_url
    };
  }

  public get fraudStatus() {
    return this.client?.fraud_status;
  }

  public get showAvatar() {
    return (this.isAdmin && !!this.client) || this.hasDelegator;
  }

  public get isDelegatedProduct() {
    return this.contractProduct?.is_delegated_object;
  }

  public get clientName() {
    return this.client?.fullname || this.client?.public_name || "";
  }

  public get entity() {
    return this.$store.getters[`data/${DataModules.CONTRACTS_PRODUCTS}/entity`](
      this.contractProduct
    );
  }

  public get tooltipLabel() {
    return this.$t("_sentence.delegates.delegated_object_tooltip_msg", {
      objectType: this.entity,
      ownerName: this.clientName
    })
      .toString()
      .replace(/\.\./, ".");
  }

  public get hasDelegator() {
    if (!this.showDelegator) return false;
    return this.isDelegatedProduct;
  }
}
